
import NewSheetForFeedsComponent from './containers/new-sheet-for-feeds.component';
import AddGoogleSheetComponent from './containers/add-google-sheet.component';
import 'types/sheets-api-v1';


/**
 * @typedef {object} ITemplateResource
 * @property {() => ng.resource.IResource<SheetsAPIV1Def.Paths.FetchTemplates.Responses.$200>} query
 */

/**
 * @return {ITemplateResource}
 */
function TemplateResource($resource, resourceActions) {
  return $resource('/api/v1/templates/:id', { id: '@_id' }, resourceActions);
}


angular.module('linkedSheets', [])
  .factory('TemplateResource', TemplateResource)
  .component('newSheetForFeedsContainer', NewSheetForFeedsComponent)
  .component('addGoogleSheetContainer', AddGoogleSheetComponent);

export const moduleName = 'linkedSheets';
export default {
  moduleName,
};